<template>
  <div>
    <TablePublic :colLists="transColLists" :tableData="[formData]" :paginationFlag="false">
      <template slot="solts" slot-scope="scope">
        <el-button @click="toTransport(scope.data)" type="text" size="small" class="button">运输记录</el-button>
      </template>
    </TablePublic>

    <Mdialog
      title="运输记录"
      :visible.sync="dialog"
      width="80%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="close"
    >
      <TransportRecord :data="formData.shippingOrderItemRespList" />
    </Mdialog>
  </div>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import Mdialog from '@/components/Mdialog'
import TransportRecord from './TransportRecord'

export default {
  name: 'Weight',
  components: {
    TablePublic,
    Mdialog,
    TransportRecord,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const _this = this
    return {
      dialog: false,

      transColLists: [
        {
          prop: 'cropBrandKeyValue',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: 'cultivationMethodSpecAttrKey',
          label: '规格',
          isTrue: true,
          formatter() {
            const arr = [
              _this.formData.ripenessLevelSpecAttrValueKey,
              _this.formData.locDetails?.slice(_this.formData.locDetails?.lastIndexOf(',') + 1),
              _this.formData.cultivationMethodSpecValueKey,
            ]

            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '单筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'shipTotalQuantity',
          label: '满筐总筐数',
          isTrue: true,
        },
        {
          prop: 'shipTotalTailContainerWeight',
          label: '尾筐总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'shipTotalNetWeight',
          label: '采摘总净重（斤）',
          isTrue: true,
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
    }
  },
  mounted() {},
  methods: {
    close() {
      this.dialog = false
    },
    toTransport() {
      this.dialog = true
    },
  },
}
</script>

<style scoped lang="less"></style>
